import React from 'react';

import { ExclamationCircleOutlined } from '@ant-design/icons';

import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import ThemedText from '@portal/components/ThemedText/ThemedText';
import { getRouteStackPath } from '@portal/config/routes';
import { TaxIdentifierType } from '@portal/enum/onboardingType';
import { useNavigation } from '@portal/hooks/useNavigation';
import { translate } from '@portal/services/i18n';

import './BcProtegeValidationError.less';

type LocationState = {
  taxIdentifier?: string;
  accountType?: TaxIdentifierType;
};

const BcProtegeValidationError: React.FC = () => {
  const navigate = useNavigation<LocationState>();
  const taxIdentifier = navigate.location.state?.taxIdentifier;
  const accountType = navigate.location.state?.accountType;

  const handleRetry = () => {
    if (!taxIdentifier) {
      navigate(getRouteStackPath('AUTH', 'REGISTER'), { replace: true });
      return;
    }
    navigate(getRouteStackPath('AUTH', 'BC_PROTEGE_VALIDATION'), {
      replace: true,
      state: { taxIdentifier, accountType },
    });
  };

  return (
    <div className="bc-protege-error">
      <div
        className="bc-protege-error__content"
        role="alert"
        aria-live="assertive"
      >
        <div className="bc-protege-error__icon-stage" aria-hidden="true">
          <span className="bc-protege-error__icon-pulse" />
          <span className="bc-protege-error__icon-circle">
            <ExclamationCircleOutlined className="bc-protege-error__icon" />
          </span>
        </div>
        <ThemedText
          variant="h2"
          fontWeight="bold"
          className="bc-protege-error__heading"
        >
          {translate('PAGES.BC_PROTEGE.ERROR.HEADING')}
        </ThemedText>
        <ThemedText variant="body" className="bc-protege-error__body">
          {translate('PAGES.BC_PROTEGE.ERROR.TITLE')}
        </ThemedText>
        <div className="bc-protege-error__actions">
          <AdvancedButton
            text={translate('PAGES.BC_PROTEGE.ERROR.RETRY')}
            onClick={handleRetry}
            testId="bc-protege-error-retry"
          />
        </div>
      </div>
    </div>
  );
};

export default BcProtegeValidationError;
